import startupsLandingStyles from "../../../../components/startups-landing/startups-landing-sections.module.css"
import styles from "../../../../components/hero/hero.module.css"
import illustrationPath from "./img/illustration.webp"
import { talentsSignupUrl } from "../../../../components/shared/constants/constants"

const Hero = () => {
	const handleTalkToAi = () => {
		window.location.href = talentsSignupUrl
	}

	return (
		<section id="hero" className={styles.heroSection}>
			<div className={styles.heroBg} aria-hidden />
			<div className={styles.heroGrid} aria-hidden />
			<div className={`container ${startupsLandingStyles.sectionContainer} ${styles.heroShell}`}>
				<div className={styles.heroInner}>
					<div className={styles.heroCopy}>
						<div className={startupsLandingStyles.label}>For talents</div>
						<h1 className={`${styles.heroHeadline} ${styles.heroHeadlineStack2}`}>
							<span className={styles.heroHeadlineLine}>Stop Job Hunting.</span>
							<span className={styles.heroHeadlineLine}>Start Matchmaking.</span>
						</h1>
						<p className={styles.heroSub}>
							Chat with Kate, your personal AI career agent. Describe your ideal role and she makes it happen. Your ally from first conversation to your next role.
						</p>
						<div className={styles.heroActions}>
							<button
								type="button"
								className={`${startupsLandingStyles.btnPrimary} ${styles.heroCtaPrimary}`}
								onClick={handleTalkToAi}
							>
								<span>Get started for free</span>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
									<path
										d="M5.25 2.625L9.625 7L5.25 11.375"
										stroke="white"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							<a href="#how-it-works" className={startupsLandingStyles.btnGhost}>
								See how it works
							</a>
						</div>
					</div>

					<div className={styles.illustration}>
						<div className={styles.illustrationFrame}>
							<img src={illustrationPath} alt="" />
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Hero
